import { useState, useEffect, useRef } from "react";
import {
    currencyFormate,
    formatInputToCapitalization,
    getVoucherDate,
    removeCurrencyComma,
} from "../Date_Formate_Utilitiy/Index";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../redux/actions/action-creator";
const FIELD_ORDER = ["first", "particular_ledger_pay_amount"];
export const usePaymentReceipt = ({
    data,
    setData,
    validations,
    refs,
    inputRefs,
    dynamicInputRef,
    setNameInput,
    contra_account_ledger_list,
    reciept_payment_account_ledger_list,
    setLastFocusedInput,
    isView
}) => {

    const dispatch = useDispatch();
    const [submitConfirm, setSubmitConfirm] = useState("");
    const { company_session } = useSelector((state) => state.common);

    const modal_state = useSelector((state) => state.common.modal_state);

    // Check if any modal is open and prevent changes
    // Blocking modals that should prevent focus on voucher inputs
    const standardModals = [
        'ledgerCreate', 'godownCreateVoucher', 'stockItemCreate',
        'period', 'changeMode', 'configure', 'voucherTypeNameSelect',
        'dispatchDetails', 'orderDetails', 'otherVoucher', 'create_group_under',
        'create_under', 'create_stock_cat', 'create_stock_company', 'create_unit'
    ];

    const isDOMModalOpen = !!(document.querySelector('.modal_link') || document.querySelector('.modal_message'));
    const isAnyModalOpen = standardModals.some(modal => modal_state?.[modal]) || isDOMModalOpen;

    const cleanString = (str) => str?.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase();

    const modalStateRef = useRef(modal_state);
    const idCounterRef = useRef(0);

    useEffect(() => {
        modalStateRef.current = modal_state;
    }, [modal_state]);

    useEffect(() => {
        if (data?.data?.length > 0) {
            const maxId = Math.max(...data.data.map(i => parseInt(i.id) || 0));
            if (maxId > idCounterRef.current) {
                idCounterRef.current = maxId;
            }
        }
    }, [data?.data]);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Escape") {
                if (submitConfirm) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    setSubmitConfirm("");
                    return;
                }
                if (isAnyModalOpen) {
                    return;
                }
                const activeModals = Object.keys(modalStateRef.current || {}).filter(key => modalStateRef.current[key]);

                // Dropdown modals are those NOT in the standard/blocking list
                const openDropdownModals = activeModals.filter(modal => !standardModals.includes(modal));

                if (openDropdownModals?.length > 0) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    openDropdownModals.forEach((modal) => {
                        dispatch(closeModal(modal));
                    });
                } else {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    document.activeElement?.blur();
                    setSubmitConfirm('Quit');
                }
            }
        };
        window.addEventListener("keydown", handleKeyPress, true);
        return () => window.removeEventListener("keydown", handleKeyPress, true);
    }, [submitConfirm, isAnyModalOpen]);

    useEffect(() => {
        if (!data?.data) return;
        const total = data.data.reduce((acc, row) => acc + safeParseNumber(row.particular_ledger_pay_amount), 0);
        if (total !== data.total_amount) {
            setData((prev) => ({
                ...prev,
                total_amount: total
            }));
        }
    }, [data.data]);

    const handleItemUpdate = (e, id, field, value) => {
        if (isAnyModalOpen || submitConfirm || isView) { // added isView
            e.preventDefault();
            return;
        }
        switch (field) {
            case "first":
                const listToVerify = [{ ledger_name: "End of List" }, ...(reciept_payment_account_ledger_list || contra_account_ledger_list || [])];
                const value_ = listToVerify?.some((item) =>
                    cleanString(item?.ledger_name)?.includes(cleanString(value))
                );
                if (value_) {
                    setData((prevState) => ({
                        ...prevState,
                        data: prevState.data.map((item, i) => {
                            if (item.id === id) {
                                const updatedItem = { ...item, [field]: value };
                                return updatedItem;
                            }
                            return item;
                        }),
                    }));
                }
                break;
            case "particular_ledger_pay_amount":
                if (/^[0-9,.\b]*$/.test(value) || value === "") {
                    setData((prevState) => ({
                        ...prevState,
                        data: prevState.data.map((item, i) => {
                            if (item.id === id) {
                                const updatedItem = { ...item, [field]: value };
                                return updatedItem;
                            }
                            return item;
                        }),
                    }));
                }
                break;
        }

        if (e.key === "Enter") {
            e.preventDefault();
        }
    };

    const handleFallbackNavigation = (e, id, field, value) => {

        const ref = dynamicInputRef.current[id];
        if (ref) {
            const currentFieldIndex = FIELD_ORDER.indexOf(field);
            const nextField = FIELD_ORDER[currentFieldIndex + 1];
            const nextRef = ref[nextField];
            if (currentFieldIndex !== -1 && currentFieldIndex < FIELD_ORDER.length - 1) {
                if ((value === "" || String(value).toLowerCase() === "end of list") && field === "first") {
                    inputRefs.narration.current.focus();
                    inputRefs.narration.current.setSelectionRange(0, inputRefs.narration.current.value?.length || 0);
                    return;
                }

                if (nextRef) {
                    setNameInput(nextRef);
                    nextRef.focus();
                    nextRef.setSelectionRange(0, nextRef.value?.length || 0);
                    return;
                }
            }

            // We're on the last field of current row, check if there's a next row
            const allRowIds = Object.keys(dynamicInputRef.current).sort((a, b) => {
                const numA = parseInt(a) || 0;
                const numB = parseInt(b) || 0;
                return numA - numB;
            });
            const currentRowIndex = allRowIds.indexOf(id);
            const nextRowId = allRowIds[currentRowIndex + 1];

            if (nextRowId) {
                const nextRowRef = dynamicInputRef.current[nextRowId];
                const firstFieldRef = nextRowRef?.[FIELD_ORDER[0]];
                if (firstFieldRef) {
                    setNameInput(firstFieldRef);
                    firstFieldRef.focus();
                    firstFieldRef.setSelectionRange(0, firstFieldRef.value?.length || 0);
                    return;
                }
            }

            // No next row exists, create a new row
            const newRowId = addRow();
            if (newRowId) {
                setTimeout(() => {
                    const newRowRef = dynamicInputRef.current[newRowId];
                    const firstFieldRef = newRowRef?.[FIELD_ORDER[0]];
                    if (firstFieldRef) {
                        setNameInput(firstFieldRef);
                        firstFieldRef.focus();
                        firstFieldRef.setSelectionRange(0, firstFieldRef.value?.length || 0);
                    }
                }, 50);
            }
        }
    };

    // Helper function to safely parse number from any format (string, number, formatted)
    const safeParseNumber = (value) => {
        if (value == null || value === '' || value === undefined) {
            return 0;
        }

        // If already a number, return it
        if (typeof value === 'number') {
            return isNaN(value) ? 0 : value;
        }

        // If string, remove commas and parse
        if (typeof value === 'string') {
            const cleaned = removeCurrencyComma(value);
            const parsed = parseFloat(cleaned);
            return isNaN(parsed) ? 0 : parsed;
        }

        return 0;
    };

    const calculatePaymentReceiptState = ({ data, id, newValue }) => {
        const rows = data.data.map((r) => ({ ...r }));
        const currentRow = rows.find((r) => r.id === id);
        if (!currentRow) return null;

        const ledgerId = currentRow.particular_ledger_id;
        const prevValue = safeParseNumber(currentRow.prev_value);
        const inputValue = safeParseNumber(newValue);

        let accountBalance = safeParseNumber(data.account_ledger_balance);

        /* =========================
           STEP 1: REVERT (UPDATE / DELETE)
           ========================= */
        if (prevValue > 0) {
            rows.forEach((row) => {
                if (row.particular_ledger_id === ledgerId) {
                    const bal = safeParseNumber(row.particular_ledger_balance);
                    // Receipt revert → ledger minus
                    row.particular_ledger_balance = currencyFormate(bal - prevValue);
                }
            });

            // Receipt revert → account plus
            accountBalance += prevValue;
        }

        /* =========================
           STEP 2: APPLY NEW (CREATE / UPDATE)
           ========================= */
        if (inputValue > 0) {
            rows.forEach((row) => {
                if (row.particular_ledger_id === ledgerId) {
                    const bal = safeParseNumber(row.particular_ledger_balance);
                    // Receipt → ledger plus
                    row.particular_ledger_balance = currencyFormate(bal + inputValue);
                }
            });

            // Receipt → account minus
            accountBalance -= inputValue;
        }
        /* =========================
           STEP 3: UPDATE CURRENT ROW META
           ========================= */
        rows.forEach((row) => {
            if (row.id === id) {
                row.prev_value = inputValue > 0 ? newValue : "";
                row.particular_ledger_pay_amount = inputValue > 0 ? currencyFormate(inputValue) : "";
            }
        });
        /* =========================
           STEP 4: TOTAL AMOUNT
           ========================= */
        const totalAmount = rows.reduce((acc, row) => {
            const amt =
                row.id === id
                    ? inputValue
                    : safeParseNumber(row.particular_ledger_pay_amount);
            return acc + amt;
        }, 0);

        return {
            updatedRows: rows,
            totalAmount,
            accountLedgerBalance: currencyFormate(accountBalance),
        };
    };

    const calculateLedgerState = ({ data, id, newValue }) => {
        const rows = data.data.map((r) => ({ ...r }));
        const currentRow = rows.find((r) => r.id === id);
        if (!currentRow) return null;

        const prevValue = safeParseNumber(currentRow.prev_value);
        const inputValue = safeParseNumber(newValue);
        const ledgerId = currentRow.particular_ledger_id;

        let accountBalance = safeParseNumber(data.account_ledger_balance);

        // STEP 1: Revert previous value (UPDATE / DELETE case)
        if (prevValue > 0) {
            rows.forEach((row) => {
                if (row.particular_ledger_id === ledgerId) {
                    const balance = safeParseNumber(row.particular_ledger_balance);
                    row.particular_ledger_balance = currencyFormate(balance + prevValue);
                }
            });
            accountBalance -= prevValue;
        }

        // STEP 2: Apply new value (CREATE / UPDATE)
        if (inputValue > 0) {
            rows.forEach((row) => {
                if (row.particular_ledger_id === ledgerId) {
                    const balance = safeParseNumber(row.particular_ledger_balance);
                    row.particular_ledger_balance = currencyFormate(balance - inputValue);
                }
            });
            accountBalance += inputValue;
        }

        // STEP 3: Update current row meta
        rows.forEach((row) => {
            if (row.id === id) {
                row.prev_value = inputValue > 0 ? newValue : "";
                row.particular_ledger_pay_amount = inputValue > 0 ? currencyFormate(inputValue) : "";
            }
        });

        // STEP 4: Recalculate total amount
        const totalAmount = rows.reduce((acc, row) => {
            const amount =
                row.id === id ? inputValue : safeParseNumber(row.particular_ledger_pay_amount);
            return acc + amount;
        }, 0);

        return {
            updatedRows: rows,
            totalAmount,
            accountLedgerBalance: currencyFormate(accountBalance),
        };
    };



    const handleTotalAmount = (id, field, value) => {
        setData((prev) => {
            const result =
                prev.voucher_type_name === "Payment" ?
                    calculatePaymentReceiptState({
                        data: prev,
                        id,
                        newValue: value,
                    })
                    :
                    calculateLedgerState({
                        data: prev,
                        id,
                        newValue: value,
                    });

            if (!result) return prev;

            return {
                ...prev,
                data: result.updatedRows,
                total_amount: result.totalAmount,
                account_ledger_balance: result.accountLedgerBalance,
            };
        });
    }

    // Handle dynamic inputs
    const handleDynamicFocus = (e, id, field, value) => {
        if (window.isRestoringVoucherFocus) {
            return;
        }
        if (isAnyModalOpen || submitConfirm || isView) { // added isView
            e.preventDefault();
            e.target.blur();
            return;
        }

        // Clean amount if focusing on a financial field --------------------------------
        if (field === "particular_ledger_pay_amount" && value) {
            const cleanVal = removeCurrencyComma(value);
            if (cleanVal !== value) {
                setData(prev => ({
                    ...prev,
                    data: prev.data.map(item => item.id === id ? { ...item, [field]: cleanVal } : item)
                }));
            }
        }

        const ref = dynamicInputRef.current[id]?.[field];
        if (ref) {
            setNameInput(ref);
            ref.setSelectionRange(0, ref.value?.length || 0);
        }
        if (field === "first") {
            dispatch(openModal(`${field}${id}`));
        }
    };

    const handleDynamicBlur = (e, id, field, value) => {
        const refKey = `${field}${id}`;
        if (field === "first") {
            if (modalStateRef.current?.[refKey]) {
                dispatch(closeModal(refKey));
            }
        }
        if (field === "particular_ledger_pay_amount") {
            if (id) {
                handleTotalAmount(id, field, value);
            }
        }
    };

    const addRow = () => {
        idCounterRef.current += 1;
        const next_id = String(idCounterRef.current);

        setData((prevFormData) => {
            const newEntry = {
                id: next_id,
                first: "",
                particular_ledger_balance: "",
                particular_ledger_id: "",
                particular_ledger_pay_amount: "",
                prev_value: ""
            };

            return {
                ...prevFormData,
                data: [...(prevFormData.data || []), newEntry],
            };
        });

        return next_id;
    };


    // for Static input fields ------------------------------------------------------------


    const handleChange = (e, index) => {
        if (isAnyModalOpen || submitConfirm || isView) { // added isView
            e.preventDefault();
            return;
        }
        const { name, value } = e.target;

        if (e.key === "Enter") {
            e.preventDefault();
            return;
        }

        // Apply field-specific validations
        const validation = validations[name];
        if (validation) {
            const isValid = validation(value);
            if (isValid || value === "") {
                setData((prevData) => {
                    const updatedData = { ...prevData };

                    if (typeof index !== "number") {
                        const updatedValue =
                            name === "name" || name === "notes"
                                ? formatInputToCapitalization(value)
                                : value;
                        updatedData[name] = updatedValue;
                    } else if (typeof index === "number") {
                        // Update array fields within `data_item`
                        updatedData.data_item = updatedData.data_item.map((item, i) =>
                            i === index ? { ...item, [name]: value } : item
                        );
                    }

                    return updatedData;
                });
            }
        } else {
            flushSync(setData({ ...data, [name]: value }));
        }
    };

    const handleDropdownClick = (name, value) => {
        let nextField = null;
        const fields = Object.keys(inputRefs);
        const currentIndex = fields.indexOf(name);
        nextField = fields[currentIndex + 1] || null;
        if (name === "account") {
            const firstRowId = data?.data?.[0]?.id;
            const nextRef = dynamicInputRef.current[firstRowId]?.first;
            if (nextRef) {
                nextRef.focus();
                nextRef.setSelectionRange(0, nextRef.value?.length || 0);
            }
        } else if (nextField && inputRefs[nextField]?.current) {
            inputRefs[nextField].current.focus();
            inputRefs[nextField].current.setSelectionRange(
                0,
                inputRefs[nextField].current.value.length
            );
            setSubmitConfirm("");
        } else if (name === "narration") {
            setSubmitConfirm("Accept");
            inputRefs[name]?.current?.blur();
        }
    };

    const handleFocus = (e, index, field) => {
        if (window.isRestoringVoucherFocus) {
            return;
        }
        if (isAnyModalOpen || submitConfirm || isView) { // added isView
            e.preventDefault();
            e.target.blur();
            return;
        }

        const { name } = e.target;
        const ref = inputRefs[name];
        if (ref) {
            setNameInput(ref);
            setLastFocusedInput && setLastFocusedInput(ref.current);
            ref?.current?.setSelectionRange(0, ref?.current?.value?.length);
        }
        if (name === "account") {
            dispatch(openModal(name));
        }

        // const focusAction = refs[name]?.onFocus;
        // if (focusAction) focusAction(index, field);
    };

    const handleBlur = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === "account") {
            if (modalStateRef.current?.[name]) {
                dispatch(closeModal(name));
            }
        }
        if (name === 'create_date' && value) {
            const dateResult = getVoucherDate(value, company_session, data?.create_date);
            if (dateResult && dateResult.formattedDateString) {
                setData((prevData) => ({
                    ...prevData,
                    create_date: dateResult.formattedDateString,
                    day_name: dateResult.day_show,
                }));
            }
        }
        if (name === 'date_payment' && value) {
            const dateResult = getVoucherDate(value, company_session, data?.date_payment || data?.create_date);
            if (dateResult && dateResult.formattedDateString) {
                setData((prevData) => ({
                    ...prevData,
                    date_payment: dateResult.formattedDateString,
                }));
            }
        }
    };

    const handleKeyDown = (e, id, field) => {
        if (submitConfirm || isView) { // block keys in View mode
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (isAnyModalOpen && (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp")) {
            return;
        }
        const { name, value } = e.target;
        if (e.key === "Space") {
            if (e.target.selectionStart === 1) {
                e.preventDefault();
                setData({ ...data, [name]: "" });
                return;
            }
        }
        if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            if (id && field) {
                if (field === "particular_ledger_pay_amount") {
                    handleTotalAmount(id, field, value);
                }
                handleFallbackNavigation(e, id, field, value);
            } else {
                if (name === 'create_date' && value) {
                    const dateResult = getVoucherDate(value, company_session, data?.create_date);
                    if (dateResult && dateResult.formattedDateString) {
                        setData((prevData) => ({
                            ...prevData,
                            create_date: dateResult.formattedDateString,
                            day_name: dateResult.day_show,
                        }));
                    }
                }
                if (name === 'date_payment' && value) {
                    const dateResult = getVoucherDate(value, company_session, data?.date_payment || data?.create_date);
                    if (dateResult && dateResult.formattedDateString) {
                        setData((prevData) => ({
                            ...prevData,
                            date_payment: dateResult.formattedDateString,
                        }));
                    }
                }
                handleDropdownClick(name, value);
            }
            return;
        }

        if (e.key === "Tab") {
            e.preventDefault();
            e.stopPropagation();

            const allRowIds = Object.keys(dynamicInputRef.current).sort((a, b) => parseInt(a) - parseInt(b));

            if (e.shiftKey) {
                // SHIFT + TAB (Backward)
                if (id && field) {
                    if (field === "particular_ledger_pay_amount") {
                        const ref = dynamicInputRef.current[id]?.first;
                        if (ref) {
                            ref.focus();
                            ref.setSelectionRange(0, ref.value?.length || 0);
                        }
                    } else if (field === "first") {
                        const currentRowIndex = allRowIds.indexOf(id);
                        if (currentRowIndex > 0) {
                            const prevRowId = allRowIds[currentRowIndex - 1];
                            const ref = dynamicInputRef.current[prevRowId]?.particular_ledger_pay_amount;
                            if (ref) {
                                ref.focus();
                                ref.setSelectionRange(0, ref.value?.length || 0);
                            }
                        } else {
                            if (inputRefs.account?.current) {
                                inputRefs.account.current.focus();
                                inputRefs.account.current.setSelectionRange(0, inputRefs.account.current.value?.length || 0);
                            }
                        }
                    }
                } else {
                    const fields = Object.keys(inputRefs).filter(f => inputRefs[f]?.current && !inputRefs[f].current.disabled);
                    const currentIndex = fields.indexOf(name);
                    if (name === "narration") {
                        const lastRowId = allRowIds[allRowIds.length - 1];
                        const lastRowItem = data?.data?.find(item => item.id == lastRowId);
                        let targetField = "particular_ledger_pay_amount";

                        // If for last item field we have with end of list then focus should be on item field otheriwse on amount field
                        if (String(lastRowItem?.first).toLowerCase() === "end of list" || !lastRowItem?.first) {
                            targetField = "first";
                        }
                        const ref = dynamicInputRef.current[lastRowId]?.[targetField];
                        if (ref) {
                            ref.focus();
                            ref.setSelectionRange(0, ref.value?.length || 0);
                        }
                    } else if (currentIndex > 0) {
                        const prevField = fields[currentIndex - 1];
                        const ref = inputRefs[prevField].current;
                        ref.focus();
                        ref.setSelectionRange(0, ref.value?.length || 0);
                    }
                }
            } else {
                // TAB (Forward)
                if (id && field) {
                    if (field === "first") {
                        const ref = dynamicInputRef.current[id]?.particular_ledger_pay_amount;
                        if (ref) {
                            ref.focus();
                            ref.setSelectionRange(0, ref.value?.length || 0);
                        }
                    } else if (field === "particular_ledger_pay_amount") {
                        const currentRowIndex = allRowIds.indexOf(id);
                        const nextRowId = allRowIds[currentRowIndex + 1];
                        if (nextRowId) {
                            const ref = dynamicInputRef.current[nextRowId]?.first;
                            if (ref) {
                                ref.focus();
                                ref.setSelectionRange(0, ref.value?.length || 0);
                            }
                        } else {
                            if (inputRefs.narration?.current) {
                                inputRefs.narration.current.focus();
                                inputRefs.narration.current.setSelectionRange(0, inputRefs.narration.current.value?.length || 0);
                            }
                        }
                    }
                } else {
                    if (name === "account") {
                        const firstRowId = allRowIds[0] || 1;
                        const ref = dynamicInputRef.current[firstRowId]?.first;
                        if (ref) {
                            ref.focus();
                            ref.setSelectionRange(0, ref.value?.length || 0);
                        }
                    } else {
                        const fields = Object.keys(inputRefs).filter(f => inputRefs[f]?.current && !inputRefs[f].current.disabled);
                        const currentIndex = fields.indexOf(name);
                        if (currentIndex < fields.length - 1) {
                            const nextField = fields[currentIndex + 1];
                            const ref = inputRefs[nextField].current;
                            ref.focus();
                            ref.setSelectionRange(0, ref.value?.length || 0);
                        }
                    }
                }
            }
        }
    };

    const handleDropdownDynamicClick = (field, value, rowIdOrIndex) => {
        const id = typeof rowIdOrIndex === 'string' ? rowIdOrIndex : data?.data?.[rowIdOrIndex]?.id;
        if (!id) return;

        const list = reciept_payment_account_ledger_list?.length > 0 ? reciept_payment_account_ledger_list : (contra_account_ledger_list || []);
        const ledger = list?.find(l => (l.ledger_name || l.name || l.symbol) === value);

        setData(prev => ({
            ...prev,
            data: prev.data.map((item) => String(item.id) === String(id) ? {
                ...item,
                [field]: value,
                particular_ledger_id: ledger ? (ledger.id || ledger.ledger_id || "") : item.particular_ledger_id,
                particular_ledger_balance: ledger ? (ledger.opening_balance || "") : item.particular_ledger_balance,
            } : item)
        }));

        dispatch(closeModal(`${field}${id}`));

        setTimeout(() => {
            handleFallbackNavigation(null, id, field, value);
        }, 50);
    };

    return {
        handleChange,
        handleFocus,
        handleBlur,
        submitConfirm,
        setSubmitConfirm,
        handleItemUpdate,
        handleDynamicFocus,
        handleDynamicBlur,
        handleDropdownClick,
        handleDropdownDynamicClick,
        handleKeyDown,
    };
};
